import styled, { css } from 'styled-components'
import { typoHeading5, typoHeading6, typoLabel } from '../../../lib/styles/Typography'
import { BlogComponentType } from '../../../types'
import React from 'react'

import { getBreakPoint } from '../../../lib/styles/breakpoints'
import { blogComponentTypeColorMap } from '../../../lib/theme'
import { RecommendedArticleAssetComponentProps } from '../types'

export const RecommendedArticleItemContentWrapperBaseStyle = css<RecommendedArticleAssetComponentProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  flex: 1 0 60%;
  @media screen and (max-width: 576px) {
    width: ${({ $isSmall }) => !$isSmall && '100%'};
  }
`

export const RecommendedArticleItemTitle = styled.span<RecommendedArticleAssetComponentProps>`
  ${({ $isSmall }) => ($isSmall ? typoHeading6 : typoHeading5)}
`

export const RecommendedArticleItemCategory = styled.span<{ component: BlogComponentType }>`
  color: ${({ component, theme }) => blogComponentTypeColorMap({ component, theme })};
  ${typoLabel};
`
export const RecommendedArticleWrapperBaseStyle = css<RecommendedArticleAssetComponentProps>`
  position: relative;
  display: flex;
  gap: ${({ $isSmall }) => ($isSmall ? '1rem' : '1.5rem')};
  align-items: center;
  background-color: ${({ theme }) => theme.colors.black[7]};
  border-radius: ${({ $isSmall }) => ($isSmall ? `0.7rem` : `1rem`)};
  color: ${({ theme }) => theme.colors.black[1]};
  text-decoration: none;

  &:hover,
  &:focus-visible {
    box-shadow: 0 0 0 2px #000;
  }

  @media (${getBreakPoint('sm')}) {
    flex-direction: ${({ $isSmall }) => !$isSmall && 'column'};
  }
`
